import moment from "moment";

export const format = date => moment(date).format('YYYY-MM-DD');